<template>
    <div class="all">
      <Head></Head>
      <div class="tesegou">
        <img src="../assets/yemianjingtaitu.jpg" alt="">
      </div>
      <div class="all_link">
        <div class="all_link_cen">
          <div class="all_link_cen_for" v-for="(item,key) in allbottom" :key="key">
            <div>{{ item.name }}</div>
            <ul>
              <li v-for="(value,key) in item.bottom_two" @click="getCliak(value.url)">{{value.name}}</li>
            </ul>
          </div>
        </div>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import {getinit, getntesegou} from '../api/index'
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import {getaddcollection, getquxiaocollection, getshopping} from "../api/List";
    export default {
        name: "tesegou2",
      components:{
        Pagetail,Head
      },
      data(){
          return{
            allbottom:[]
          }
      },
      mounted() {
          this.init()
      },
      methods:{
        getCliak(url){
          // console.log(url)
          window.open(url)
        },
        init() {
          getinit().then(res => {
            this.allbottom = res.bottom;
          });
        },
      }
    }
</script>

<style scoped lang="less">
  @import "css/tesegou2";
  .tesegou{
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/tesegou2.vue